import React from "react";
import { connect } from "react-redux";
import { LinkSection } from "components/base/LinkSection";
import { TickCampaignQuestionsAndOptionsSection } from "components/campaign/campaignCreation/ProfileSection";
import SinglePreviewCard from "components/campaignStreamline/SinglePreviewCard";
import { TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY } from "config/PageAnchorConfig/TicketCampaignAnchorConfig";


const getEventPropertiesCard = (campaignData, step) => [
  {
    step,
    sectionTitle: "REQUIREMENTS",
    anchorKey: TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.requirements.sectionKey,
    sectionContent: [
      {
        isMandatory: true,
        isBoolean: true,
        title: "Points are required to redeem",
        field: 'requirePointsToRedeem',
        anchorKey: TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.requirements.sectionContent.requirePointsToRedeemKey,
      },
      ...campaignData?.requirePointsToRedeem ? [
        {
          isMandatory: true,
          title: "Required points",
          field: 'requiredPoints',
          anchorKey: TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.requirements.sectionContent.requiredPointsKey,
        },
      ] : [],

      {
        isMandatory: true,
        isBoolean: true,
        title: "Enable OTP",
        field: 'enableOtp',
        anchorKey: TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.requirements.sectionContent.enableOtpKey,
      },
    ]
  },
  {
    step,
    sectionTitle: "Set time slot by linking the ticket",
    anchorKey: TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.timeSlot.sectionKey,
    sectionContent: [
      {
        isMandatory: true,
        title: "Link to ticket set",
        errorField: "ticketCampaignTimeSlots",
        customRender: <ul className="first-ul">
          {campaignData?.ticketCampaignTimeSlots?.map((item) => (
            <li className="create-section-field-input">
              {item.couponSet?.pk ?
                <div>
                  <label className="create-section-field-input profile-section-label-bottom">
                    {`[ID: ${item.couponSet?.pk}] ${item.couponSet?.name}`}
                  </label>
                  <LinkSection
                    link={`/tickets/${item.couponSet.pk}/`}
                    linkText={'View ticket set'}
                    disableLink={item.couponSet.toDelete}
                    disableLinkText={"Deleted"}
                    openNewTab
                  />
                </div> : "-"}
              <ul className="second-ul">
                <li
                  className="create-section-field-input"
                  style={{ color: '#979797' }}
                >
                  {`Acquired/Used/Total Stock: ${item.couponSet?.totalNumberOfAcquiredCoupons || 0
                    }/${item.couponSet?.totalNumberOfUsedCoupons || 0}/${item.couponSet?.totalNumberOfGeneratedCoupons || 0
                    }`}
                </li>
              </ul>
            </li>
          ))}
        </ul>,
        anchorKey: TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.timeSlot.sectionContent.timeSlotKey,
      },
      {
        title: "Total number of tickets from linked ticket set",
        field: 'displayTotalTicketNumber',
        anchorKey: TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.timeSlot.sectionContent.timeSlotKey,
      },
    ]
  },
  {
    step,
    sectionTitle: "OTHER INFORMATION",
    anchorKey: TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.otherInformation.sectionKey,
    sectionContent: [
      {
        isMandatory: true,
        isBoolean: true,
        title: "Fill other information",
        field: 'fillOtherInfomation',
        anchorKey: TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.otherInformation.sectionContent.fillOtherInformationKey,
      },
      ...campaignData?.fillOtherInfomation ? [
        {
          isMandatory: true,
          title: "Questions and options",
          errorField: "ticketCampaignAdditionalQuestion",
          customRender: <TickCampaignQuestionsAndOptionsSection campaign={campaignData} title="" />,
          anchorKey: TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.otherInformation.sectionContent.otherInfoInputSectionKey,
        },
      ] : [],
    ]
  },
  {
    step,
    sectionTitle: "LIMITS",
    anchorKey: TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.limits.sectionKey,
    sectionContent: [
      {
        isMandatory: true,
        isBoolean: true,
        title: "LIMITS",
        field: 'haveLimitsField',
        anchorKey: TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.limits.sectionContent.haveLimitsKey,
      },
      ...campaignData?.haveLimitsField ? [
        {
          isMandatory: true,
          isBoolean: true,
          title: "Display the overall limit in the event",
          field: 'displayOverLimit',
          anchorKey: TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.limits.sectionContent.couponAcquiringLimitKey,
        },
        {
          isMandatory: true,
          title: "Per head ticket acquiring limit during the event active period",
          field: 'displayPerHeadLimit',
          anchorKey: TICKET_CAMPAIGN_PROPERTIES_PAGE_ANCHOR_KEY.limits.sectionContent.perHeadLimitKey,
        },
      ] : [],
    ]
  },
];
const EventPreviewPropertiesCard = ({
  errors,
  campaignData,
  language,
  hideEditButton = false,
}) => {
  const step = 1;
  const getDisplayTotalTicketNumber = () => {
    const allTicketSet = campaignData?.ticketCampaignTimeSlots?.map((item) => item?.couponSet)
    let totalAcquiredCoupon = 0;
    let totalUsedCoupon = 0;
    let totalStock = 0;
    allTicketSet?.length > 0 &&
      allTicketSet.forEach((ticket) => {
        totalAcquiredCoupon += ticket?.totalNumberOfAcquiredCoupons || 0;
        totalUsedCoupon += ticket?.totalNumberOfUsedCoupons || 0;
        totalStock += ticket?.totalNumberOfGeneratedCoupons || 0;
      });
    return `Acquired/Used/Total Stock: ${totalAcquiredCoupon}/${totalUsedCoupon}/${totalStock}`;
  }
  const contentData = {
    ...campaignData,
    displayPerHeadLimit: `${campaignData?.perHeadLimit || 0} number of tickets`,
    displayTotalTicketNumber: getDisplayTotalTicketNumber(),
  }

  return (
    <>
      <SinglePreviewCard
        language={language}
        data={contentData}
        cardInfo={getEventPropertiesCard(contentData, step)}
        errors={errors}
        hideEditButton={hideEditButton}
      />
    </>)
}

const mapPropsToState = (state) => ({
  errors: state.createCampaign.errorFields,
});

export default connect(mapPropsToState)(EventPreviewPropertiesCard);